export const SEARCH_ENGINE = {
    DESKTOP_FIRST_COLUMN_WIDTH: '444px',
    MAP_SEARCH_FIRST_COLUMN_WIDTH: '340px',
    MAX_WIDTH: '954px',
};
